"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    objectsTable: {
        path: "/objects/:groupId"
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvY3VzdG9tT2JqZWN0cy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIG9iamVjdHNUYWJsZToge1xuICAgIHBhdGg6IFwiL29iamVjdHMvOmdyb3VwSWRcIixcbiAgfSxcbn0pO1xuIl0sIm5hbWVzIjpbInJvdXRlcyIsImJ1aWxkUm91dGVzIiwib2JqZWN0c1RhYmxlIiwicGF0aCJdLCJtYXBwaW5ncyI6Ijs7OzsrQkFFYUE7OztlQUFBQTs7O3VCQUZlO0FBRXJCLE1BQU1BLFNBQVNDLElBQUFBLGtCQUFXLEVBQUM7SUFDaENDLGNBQWM7UUFDWkMsTUFBTTtJQUNSO0FBQ0YifQ==